/** Zahlungsarten – konsistent mit DB CHECK und api/schemas/payment.py */

export type PaymentMethod = "cash" | "card" | "transfer" | "other";

export const PAYMENT_METHODS: PaymentMethod[] = ["cash", "card", "transfer", "other"];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: "Bar",
  card: "Karte",
  transfer: "Überweisung",
  other: "Sonstiges",
};

export function paymentMethodLabel(method: string): string {
  const key = method as PaymentMethod;
  return PAYMENT_METHOD_LABELS[key] ?? method;
}
